<script lang="ts">
  import { onMount } from "svelte";

  import Breadcrumb from "@retailer/svelte/Payments/InvoiceBreadcrumb.svelte";
  import Credit from "@retailer/svelte/Payments/Credits/detail/Credit.svelte";

  // stores
  import { InvoiceStore } from "@retailer/stores/InvoiceStore";

  // services
  import * as InvoiceService from "@retailer/services/invoice_service";
  import * as creditsService from "@retailer/services/credits_service";

  // props
  export let invoiceId: number;

  // data
  let previousParams = window["$rootScope"].previousParams;
  let paymentsEnabled = window["$rootScope"].user.term_payments;

  onMount(async () => {
    if (!paymentsEnabled) window.location.href = "/";
    (async () => {
      await InvoiceService.get(invoiceId);
      await creditsService.getRedemptions(invoiceId);
    })();
  });

  // reactives
  $: heading = $InvoiceStore.invoice
    ? $InvoiceStore.invoice.distributor.name + " #" + $InvoiceStore.invoice.invoice_reference_id
    : "";

</script>

<div class="fizz-styles">
  <div class="fizz-layout-primary">
    <Breadcrumb {heading} backLink={"layout.invoices_credits"} backLinkParams={previousParams} />
    <Credit />
  </div>
</div>
